/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { createContext, useContext } from "react";

import type { NavigationEngine } from "../../model/navigation/NavigationEngine";

/**
 * React context for the NavigationEngine instance.
 * Populated by `<NavigationProvider>` at the app root.
 */
export const NavigationContext = createContext<NavigationEngine | null>(null);

/**
 * Returns the NavigationEngine instance from the nearest NavigationProvider.
 * Throws if used outside a NavigationProvider.
 */
export function useNavigationEngine(): NavigationEngine {
  const engine = useContext(NavigationContext);
  if (engine === null) {
    throw new Error(
      "useNavigationEngine must be used within a <NavigationProvider>"
    );
  }
  return engine;
}
